import GeneralNotesModule from '@/modules/general-notes';

const GeneralNotes = () => {
  return <GeneralNotesModule />;
};

export default GeneralNotes;
